export default __webpack_public_path__ + "static/media/Peach waves1.a1d93ffb.jpg";